const SettingTab = {
    get:()=>'store/settings',
    update:()=>'store/settings',
    message:()=>'store/greetings',
  }
  export default SettingTab